export const signedOrdersSchema = {
    id: '/signedOrdersSchema',
    type: 'array',
    items: {$ref: '/signedOrderSchema'},
};



// WEBPACK FOOTER //
// ./~/0x.js/src/schemas/signed_orders_schema.ts